module.exports = __webpack_public_path__ + "static/cat-icon-2595aa3a10a79c7c82b9999b17a37e00.jpg";